export const getPaddingBasedOnAsset = (
  isVideoStage: boolean = false,
  defaultPadding: string = '0',
) => {
  return isVideoStage ? 'var(--spacing-relative-8xl)' : defaultPadding;
};
